/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CrmId} from '../models/CrmId';
import type {Error} from '../models/Error';

export interface GetAccountCrmId$Request {
    accountId: number;
}

export interface GetAccountCrmId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountCrmIdRequest = createAction<PayloadData<void, GetAccountCrmId$Request>>('GET_ACCOUNT_CRM_ID__GET_ACCOUNT_CRM_ID__REQUEST');
export const getAccountCrmIdSuccess = createAction<PayloadData<CrmId, GetAccountCrmId$Request>>('GET_ACCOUNT_CRM_ID__GET_ACCOUNT_CRM_ID__SUCCESS');
export const getAccountCrmIdFailure = createAction<PayloadData<Error, GetAccountCrmId$Request, true>>('GET_ACCOUNT_CRM_ID__GET_ACCOUNT_CRM_ID__FAILURE');

export const getAccountCrmIdActions = [
    getAccountCrmIdRequest,
    getAccountCrmIdSuccess,
    getAccountCrmIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountCrmId = (meta: GetAccountCrmId$Request, config?: GetAccountCrmId$Config) => {
    return {
        CALL_API: {
            types: getAccountCrmIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/crm-ids`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

